import DoorJournal from '@/services/api/door-journal';

export default {
  state: {
    journal: [],
  },
  getters: {
    journal: state => state.journal,
  },
  mutations: {
    setJournal: (state, payload) => {
      state.journal = payload;
    },
  },
  actions: {
    getJournal (state, options = {}) {
      return new Promise((resolve, reject) => {
        DoorJournal.getJournal(options)
          .then((response) => {
            state.commit('setJournal', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    importJournal (state, id) {
      return new Promise((resolve, reject) => {
        DoorJournal.importJournal(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
